var _typeof = require("/Users/hentrymartin/Development/rc-here-maps-example/node_modules/@babel/runtime/helpers/typeof");

module.exports = function (e) {
  function t(r) {
    if (n[r]) return n[r].exports;
    var o = n[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
  }

  var n = {};
  return t.m = e, t.c = n, t.d = function (e, n, r) {
    t.o(e, n) || Object.defineProperty(e, n, {
      configurable: !1,
      enumerable: !0,
      get: r
    });
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(n, "a", n), n;
  }, t.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, t.p = "/dist/", t(t.s = 6);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  (function (t) {
    var r = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    };

    if ("production" !== t.env.NODE_ENV) {
      var o = "function" === typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
          i = function i(e) {
        return "object" === ("undefined" === typeof e ? "undefined" : r(e)) && null !== e && e.$$typeof === o;
      };

      e.exports = n(8)(i, !0);
    } else e.exports = n(11)();
  }).call(t, n(3));
}, function (e, t, n) {
  "use strict";

  function r(e) {
    for (var t in e) {
      if (e.hasOwnProperty(t)) return !1;
    }

    return !0;
  }

  function o(e, t) {
    var n = Object.prototype.toString.call(e);
    if (n !== Object.prototype.toString.call(t)) return !1;
    if (["[object Array]", "[object Object]"].indexOf(n) < 0) return !1;
    var r = "[object Array]" === n ? e.length : Object.keys(e).length;
    if (r !== ("[object Array]" === n ? t.length : Object.keys(t).length)) return !1;

    var i = function i(e, t) {
      var n = Object.prototype.toString.call(e);

      if (["[object Array]", "[object Object]"].indexOf(n) >= 0) {
        if (!o(e, t)) return !1;
      } else {
        if (n !== Object.prototype.toString.call(t)) return !1;

        if ("[object Function]" === n) {
          if (e.toString() !== t.toString()) return !1;
        } else if (e !== t) return !1;
      }
    };

    if ("[object Array]" === n) {
      for (var a = 0; a < r; a++) {
        if (!1 === i(e[a], t[a])) return !1;
      }
    } else for (var u in e) {
      if (e.hasOwnProperty(u) && !1 === i(e[u], t[u])) return !1;
    }

    return !0;
  }

  t.a = r, t.b = o;
}, function (e, t) {
  function n() {
    throw new Error("setTimeout has not been defined");
  }

  function r() {
    throw new Error("clearTimeout has not been defined");
  }

  function o(e) {
    if (l === setTimeout) return setTimeout(e, 0);
    if ((l === n || !l) && setTimeout) return l = setTimeout, setTimeout(e, 0);

    try {
      return l(e, 0);
    } catch (t) {
      try {
        return l.call(null, e, 0);
      } catch (t) {
        return l.call(this, e, 0);
      }
    }
  }

  function i(e) {
    if (f === clearTimeout) return clearTimeout(e);
    if ((f === r || !f) && clearTimeout) return f = clearTimeout, clearTimeout(e);

    try {
      return f(e);
    } catch (t) {
      try {
        return f.call(null, e);
      } catch (t) {
        return f.call(this, e);
      }
    }
  }

  function a() {
    b && d && (b = !1, d.length ? y = d.concat(y) : h = -1, y.length && u());
  }

  function u() {
    if (!b) {
      var e = o(a);
      b = !0;

      for (var t = y.length; t;) {
        for (d = y, y = []; ++h < t;) {
          d && d[h].run();
        }

        h = -1, t = y.length;
      }

      d = null, b = !1, i(e);
    }
  }

  function c(e, t) {
    this.fun = e, this.array = t;
  }

  function s() {}

  var l,
      f,
      p = e.exports = {};
  !function () {
    try {
      l = "function" === typeof setTimeout ? setTimeout : n;
    } catch (e) {
      l = n;
    }

    try {
      f = "function" === typeof clearTimeout ? clearTimeout : r;
    } catch (e) {
      f = r;
    }
  }();
  var d,
      y = [],
      b = !1,
      h = -1;
  p.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
      t[n - 1] = arguments[n];
    }
    y.push(new c(e, t)), 1 !== y.length || b || o(u);
  }, c.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = s, p.addListener = s, p.once = s, p.off = s, p.removeListener = s, p.removeAllListeners = s, p.emit = s, p.prependListener = s, p.prependOnceListener = s, p.listeners = function (e) {
    return [];
  }, p.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, p.cwd = function () {
    return "/";
  }, p.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, p.umask = function () {
    return 0;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  var r = n(15);
  "string" === typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0
  };
  o.transform = void 0;
  n(17)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(7),
      o = n(19),
      i = n(21),
      a = n(22),
      u = n(23),
      c = n(24);
  n.d(t, "HereMap", function () {
    return r.a;
  }), n.d(t, "Marker", function () {
    return o.a;
  }), n.d(t, "Polygon", function () {
    return i.a;
  }), n.d(t, "Polyline", function () {
    return a.a;
  }), n.d(t, "Circle", function () {
    return u.a;
  }), n.d(t, "Rectangle", function () {
    return c.a;
  });
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" !== _typeof(t) && "function" !== typeof t ? e : t;
  }

  function i(e, t) {
    if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var a = n(0),
      u = n.n(a),
      c = n(1),
      s = n.n(c),
      l = n(12),
      f = n(5),
      p = (n.n(f), function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }()),
      d = function (e) {
    function t(e) {
      r(this, t);
      var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.onMapLoaded = function (e, t) {
        n.setState({
          map: e,
          behavior: t
        }), n.props.onMapLoaded(e);
      }, n.state = {
        map: {},
        behavior: {}
      }, n;
    }

    return i(t, e), p(t, [{
      key: "render",
      value: function value() {
        var e = this.state,
            t = e.map,
            n = e.behavior,
            r = this.props.children;
        return u.a.createElement("div", {
          className: "here-map-container"
        }, u.a.createElement(l.a, Object.assign({}, this.props, {
          onMapLoaded: this.onMapLoaded
        })), u.a.Children.map(r, function (e) {
          return e ? u.a.cloneElement(e, {
            map: t,
            behavior: n
          }) : null;
        }));
      }
    }]), t;
  }(a.PureComponent);

  d.defaultProps = {
    appId: "",
    appCode: "",
    useHTTPS: !0,
    onMapLoaded: function onMapLoaded() {},
    center: {
      lng: 13.4,
      lat: 52.51
    },
    bounds: {},
    zoom: 10
  }, d.propTypes = {
    appId: s.a.string,
    appCode: s.a.string,
    useHTTPS: s.a.bool,
    onMapLoaded: s.a.func,
    center: s.a.object,
    bounds: s.a.object,
    zoom: s.a.number
  }, t.a = d;
}, function (e, t, n) {
  "use strict";

  (function (t) {
    function r() {
      return null;
    }

    var o = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    },
        i = n(9),
        a = n(4),
        u = n(10),
        c = function c() {};

    "production" !== t.env.NODE_ENV && (c = function c(e) {
      var t = "Warning: " + e;
      "undefined" !== typeof console && console.error(t);

      try {
        throw new Error(t);
      } catch (e) {}
    }), e.exports = function (e, n) {
      function s(e) {
        var t = e && (T && e[T] || e[_]);
        if ("function" === typeof t) return t;
      }

      function l(e, t) {
        return e === t ? 0 !== e || 1 / e === 1 / t : e !== e && t !== t;
      }

      function f(e) {
        this.message = e, this.stack = "";
      }

      function p(e) {
        function r(r, u, s, l, p, d, y) {
          if (l = l || S, d = d || s, y !== a) {
            if (n) {
              var b = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw b.name = "Invariant Violation", b;
            }

            if ("production" !== t.env.NODE_ENV && "undefined" !== typeof console) {
              var h = l + ":" + s;
              !o[h] && i < 3 && (c("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), o[h] = !0, i++);
            }
          }

          return null == u[s] ? r ? new f(null === u[s] ? "The " + p + " `" + d + "` is marked as required in `" + l + "`, but its value is `null`." : "The " + p + " `" + d + "` is marked as required in `" + l + "`, but its value is `undefined`.") : null : e(u, s, l, p, d);
        }

        if ("production" !== t.env.NODE_ENV) var o = {},
            i = 0;
        var u = r.bind(null, !1);
        return u.isRequired = r.bind(null, !0), u;
      }

      function d(e) {
        function t(t, n, r, o, i, a) {
          var u = t[n];
          if (P(u) !== e) return new f("Invalid " + o + " `" + i + "` of type `" + k(u) + "` supplied to `" + r + "`, expected `" + e + "`.");
          return null;
        }

        return p(t);
      }

      function y(e) {
        function t(t, n, r, o, i) {
          if ("function" !== typeof e) return new f("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
          var u = t[n];

          if (!Array.isArray(u)) {
            return new f("Invalid " + o + " `" + i + "` of type `" + P(u) + "` supplied to `" + r + "`, expected an array.");
          }

          for (var c = 0; c < u.length; c++) {
            var s = e(u, c, r, o, i + "[" + c + "]", a);
            if (s instanceof Error) return s;
          }

          return null;
        }

        return p(t);
      }

      function b(e) {
        function t(t, n, r, o, i) {
          if (!(t[n] instanceof e)) {
            var a = e.name || S;
            return new f("Invalid " + o + " `" + i + "` of type `" + C(t[n]) + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
          }

          return null;
        }

        return p(t);
      }

      function h(e) {
        function n(t, n, r, o, i) {
          for (var a = t[n], u = 0; u < e.length; u++) {
            if (l(a, e[u])) return null;
          }

          return new f("Invalid " + o + " `" + i + "` of value `" + a + "` supplied to `" + r + "`, expected one of " + JSON.stringify(e) + ".");
        }

        return Array.isArray(e) ? p(n) : ("production" !== t.env.NODE_ENV && c("Invalid argument supplied to oneOf, expected an instance of array."), r);
      }

      function m(e) {
        function t(t, n, r, o, i) {
          if ("function" !== typeof e) return new f("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
          var u = t[n],
              c = P(u);
          if ("object" !== c) return new f("Invalid " + o + " `" + i + "` of type `" + c + "` supplied to `" + r + "`, expected an object.");

          for (var s in u) {
            if (u.hasOwnProperty(s)) {
              var l = e(u, s, r, o, i + "." + s, a);
              if (l instanceof Error) return l;
            }
          }

          return null;
        }

        return p(t);
      }

      function v(e) {
        function n(t, n, r, o, i) {
          for (var u = 0; u < e.length; u++) {
            if (null == (0, e[u])(t, n, r, o, i, a)) return null;
          }

          return new f("Invalid " + o + " `" + i + "` supplied to `" + r + "`.");
        }

        if (!Array.isArray(e)) return "production" !== t.env.NODE_ENV && c("Invalid argument supplied to oneOfType, expected an instance of array."), r;

        for (var o = 0; o < e.length; o++) {
          var i = e[o];
          if ("function" !== typeof i) return c("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + E(i) + " at index " + o + "."), r;
        }

        return p(n);
      }

      function g(e) {
        function t(t, n, r, o, i) {
          var u = t[n],
              c = P(u);
          if ("object" !== c) return new f("Invalid " + o + " `" + i + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");

          for (var s in e) {
            var l = e[s];

            if (l) {
              var p = l(u, s, r, o, i + "." + s, a);
              if (p) return p;
            }
          }

          return null;
        }

        return p(t);
      }

      function w(e) {
        function t(t, n, r, o, u) {
          var c = t[n],
              s = P(c);
          if ("object" !== s) return new f("Invalid " + o + " `" + u + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");
          var l = i({}, t[n], e);

          for (var p in l) {
            var d = e[p];
            if (!d) return new f("Invalid " + o + " `" + u + "` key `" + p + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
            var y = d(c, p, r, o, u + "." + p, a);
            if (y) return y;
          }

          return null;
        }

        return p(t);
      }

      function O(t) {
        switch ("undefined" === typeof t ? "undefined" : o(t)) {
          case "number":
          case "string":
          case "undefined":
            return !0;

          case "boolean":
            return !t;

          case "object":
            if (Array.isArray(t)) return t.every(O);
            if (null === t || e(t)) return !0;
            var n = s(t);
            if (!n) return !1;
            var r,
                i = n.call(t);

            if (n !== t.entries) {
              for (; !(r = i.next()).done;) {
                if (!O(r.value)) return !1;
              }
            } else for (; !(r = i.next()).done;) {
              var a = r.value;
              if (a && !O(a[1])) return !1;
            }

            return !0;

          default:
            return !1;
        }
      }

      function j(e, t) {
        return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" === typeof Symbol && t instanceof Symbol;
      }

      function P(e) {
        var t = "undefined" === typeof e ? "undefined" : o(e);
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : j(t, e) ? "symbol" : t;
      }

      function k(e) {
        if ("undefined" === typeof e || null === e) return "" + e;
        var t = P(e);

        if ("object" === t) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }

        return t;
      }

      function E(e) {
        var t = k(e);

        switch (t) {
          case "array":
          case "object":
            return "an " + t;

          case "boolean":
          case "date":
          case "regexp":
            return "a " + t;

          default:
            return t;
        }
      }

      function C(e) {
        return e.constructor && e.constructor.name ? e.constructor.name : S;
      }

      var T = "function" === typeof Symbol && Symbol.iterator,
          _ = "@@iterator",
          S = "<<anonymous>>",
          x = {
        array: d("array"),
        bool: d("boolean"),
        func: d("function"),
        number: d("number"),
        object: d("object"),
        string: d("string"),
        symbol: d("symbol"),
        any: function () {
          return p(r);
        }(),
        arrayOf: y,
        element: function () {
          function t(t, n, r, o, i) {
            var a = t[n];

            if (!e(a)) {
              return new f("Invalid " + o + " `" + i + "` of type `" + P(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
            }

            return null;
          }

          return p(t);
        }(),
        instanceOf: b,
        node: function () {
          function e(e, t, n, r, o) {
            return O(e[t]) ? null : new f("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
          }

          return p(e);
        }(),
        objectOf: m,
        oneOf: h,
        oneOfType: v,
        shape: g,
        exact: w
      };
      return f.prototype = Error.prototype, x.checkPropTypes = u, x.PropTypes = x, x;
    };
  }).call(t, n(3));
}, function (e, t, n) {
  "use strict";

  function r(e) {
    if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  var o = Object.getOwnPropertySymbols,
      i = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;
  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, u, c = r(e), s = 1; s < arguments.length; s++) {
      n = Object(arguments[s]);

      for (var l in n) {
        i.call(n, l) && (c[l] = n[l]);
      }

      if (o) {
        u = o(n);

        for (var f = 0; f < u.length; f++) {
          a.call(n, u[f]) && (c[u[f]] = n[u[f]]);
        }
      }
    }

    return c;
  };
}, function (e, t, n) {
  "use strict";

  (function (t) {
    function r(e, n, r, c, s) {
      if ("production" !== t.env.NODE_ENV) for (var l in e) {
        if (e.hasOwnProperty(l)) {
          var f;

          try {
            if ("function" !== typeof e[l]) {
              var p = Error((c || "React class") + ": " + r + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o(e[l]) + "`.");
              throw p.name = "Invariant Violation", p;
            }

            f = e[l](n, l, c, r, null, a);
          } catch (e) {
            f = e;
          }

          if (!f || f instanceof Error || i((c || "React class") + ": type specification of " + r + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + ("undefined" === typeof f ? "undefined" : o(f)) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), f instanceof Error && !(f.message in u)) {
            u[f.message] = !0;
            var d = s ? s() : "";
            i("Failed " + r + " type: " + f.message + (null != d ? d : ""));
          }
        }
      }
    }

    var o = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    },
        i = function i() {};

    if ("production" !== t.env.NODE_ENV) {
      var a = n(4),
          u = {};

      i = function i(e) {
        var t = "Warning: " + e;
        "undefined" !== typeof console && console.error(t);

        try {
          throw new Error(t);
        } catch (e) {}
      };
    }

    e.exports = r;
  }).call(t, n(3));
}, function (e, t, n) {
  "use strict";

  function r() {}

  var o = n(4);

  e.exports = function () {
    function e(e, t, n, r, i, a) {
      if (a !== o) {
        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw u.name = "Invariant Violation", u;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" !== _typeof(t) && "function" !== typeof t ? e : t;
  }

  function i(e, t) {
    if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var a = n(0),
      u = n.n(a),
      c = n(13),
      s = n.n(c),
      l = n(1),
      f = n.n(l),
      p = n(14),
      d = n(2),
      y = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      b = function (e) {
    function t(e) {
      r(this, t);
      var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.setMap = function (e, t) {
        n.setState({
          map: e
        }, function () {
          var r = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(e));
          window.H.ui.UI.createDefault(e, t), n.props.onMapLoaded(e, r);
        });
      }, n.updateCenter = function (e) {
        Object(d.a)(e) || n.state.map.setCenter(e);
      }, n.updateBounds = function (e) {
        if (!Object(d.a)(e)) {
          var t = new window.H.geo.Rect(e.north, e.south, e.east, e.west);
          n.state.map.setViewBounds(t);
        }
      }, n.factory = Object(p.a)(e.appId, e.appCode, e.useHTTPS), n.platform = n.factory.getPlatform(), n.state = {
        map: null
      }, n;
    }

    return i(t, e), y(t, [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        return this.state.map && (Object(d.b)(this.props.center, e.center) || this.updateCenter(e.center), Object(d.b)(this.props.bounds, e.bounds) || this.updateBounds(e.bounds)), !!this.state.map;
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var e = this.platform.createDefaultLayers(),
            t = s.a.findDOMNode(this),
            n = this.props,
            r = n.zoom,
            o = n.center,
            i = window.devicePixelRatio || 1,
            a = this.factory.getHereMap(t, e.normal.map, {
          zoom: r,
          center: o,
          pixelRatio: i
        });
        this.setMap(a, e);
      }
    }, {
      key: "render",
      value: function value() {
        return u.a.createElement("div", {
          className: "here-map-container"
        });
      }
    }]), t;
  }(a.Component);

  b.defaultProps = {
    onMapLoaded: function onMapLoaded() {},
    appId: "",
    appCode: "",
    useHTTPS: !1,
    center: {
      lng: 13.4,
      lat: 52.51
    },
    bounds: {},
    zoom: 10
  }, b.propTypes = {
    onMapLoaded: f.a.func,
    appId: f.a.string,
    appCode: f.a.string,
    useHTTPS: f.a.bool,
    center: f.a.object,
    bounds: f.a.object,
    zoom: f.a.number
  }, t.a = b;
}, function (e, t) {
  e.exports = require("react-dom");
}, function (e, t, n) {
  "use strict";

  t.a = function (e, t) {
    var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
    return {
      appId: e,
      appCode: t,
      useHTTPS: n,
      getPlatform: function getPlatform() {
        return new window.H.service.Platform({
          app_id: e,
          app_code: t,
          useHTTPS: n
        });
      },
      getHereMap: function getHereMap(e, t, n) {
        return new window.H.Map(e, t, n);
      }
    };
  };
}, function (e, t, n) {
  t = e.exports = n(16)(void 0), t.push([e.i, ".here-map-container {\n  height: 100%;\n  width: 100%; }\n", ""]);
}, function (e, t) {
  function n(e, t) {
    var n = e[1] || "",
        o = e[3];
    if (!o) return n;

    if (t && "function" === typeof btoa) {
      var i = r(o);
      return [n].concat(o.sources.map(function (e) {
        return "/*# sourceURL=" + o.sourceRoot + e + " */";
      })).concat([i]).join("\n");
    }

    return [n].join("\n");
  }

  function r(e) {
    return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
  }

  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var r = n(t, e);
        return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
      }).join("");
    }, t.i = function (e, n) {
      "string" === typeof e && (e = [[null, e, ""]]);

      for (var r = {}, o = 0; o < this.length; o++) {
        var i = this[o][0];
        "number" === typeof i && (r[i] = !0);
      }

      for (o = 0; o < e.length; o++) {
        var a = e[o];
        "number" === typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
      }
    }, t;
  };
}, function (e, t, n) {
  function r(e, t) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n],
          o = y[r.id];

      if (o) {
        o.refs++;

        for (var i = 0; i < o.parts.length; i++) {
          o.parts[i](r.parts[i]);
        }

        for (; i < r.parts.length; i++) {
          o.parts.push(l(r.parts[i], t));
        }
      } else {
        for (var a = [], i = 0; i < r.parts.length; i++) {
          a.push(l(r.parts[i], t));
        }

        y[r.id] = {
          id: r.id,
          refs: 1,
          parts: a
        };
      }
    }
  }

  function o(e, t) {
    for (var n = [], r = {}, o = 0; o < e.length; o++) {
      var i = e[o],
          a = t.base ? i[0] + t.base : i[0],
          u = i[1],
          c = i[2],
          s = i[3],
          l = {
        css: u,
        media: c,
        sourceMap: s
      };
      r[a] ? r[a].parts.push(l) : n.push(r[a] = {
        id: a,
        parts: [l]
      });
    }

    return n;
  }

  function i(e, t) {
    var n = h(e.insertInto);
    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var r = g[g.length - 1];
    if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), g.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
      if ("object" !== _typeof(e.insertAt) || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = h(e.insertInto + " " + e.insertAt.before);
      n.insertBefore(t, o);
    }
  }

  function a(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var t = g.indexOf(e);
    t >= 0 && g.splice(t, 1);
  }

  function u(e) {
    var t = document.createElement("style");
    return e.attrs.type = "text/css", s(t, e.attrs), i(e, t), t;
  }

  function c(e) {
    var t = document.createElement("link");
    return e.attrs.type = "text/css", e.attrs.rel = "stylesheet", s(t, e.attrs), i(e, t), t;
  }

  function s(e, t) {
    Object.keys(t).forEach(function (n) {
      e.setAttribute(n, t[n]);
    });
  }

  function l(e, t) {
    var n, r, o, i;

    if (t.transform && e.css) {
      if (!(i = t.transform(e.css))) return function () {};
      e.css = i;
    }

    if (t.singleton) {
      var s = v++;
      n = m || (m = u(t)), r = f.bind(null, n, s, !1), o = f.bind(null, n, s, !0);
    } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (n = c(t), r = d.bind(null, n, t), o = function o() {
      a(n), n.href && URL.revokeObjectURL(n.href);
    }) : (n = u(t), r = p.bind(null, n), o = function o() {
      a(n);
    });

    return r(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        r(e = t);
      } else o();
    };
  }

  function f(e, t, n, r) {
    var o = n ? "" : r.css;
    if (e.styleSheet) e.styleSheet.cssText = O(t, o);else {
      var i = document.createTextNode(o),
          a = e.childNodes;
      a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
    }
  }

  function p(e, t) {
    var n = t.css,
        r = t.media;
    if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = n;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(n));
    }
  }

  function d(e, t, n) {
    var r = n.css,
        o = n.sourceMap,
        i = void 0 === t.convertToAbsoluteUrls && o;
    (t.convertToAbsoluteUrls || i) && (r = w(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
    var a = new Blob([r], {
      type: "text/css"
    }),
        u = e.href;
    e.href = URL.createObjectURL(a), u && URL.revokeObjectURL(u);
  }

  var y = {},
      b = function (e) {
    var t;
    return function () {
      return "undefined" === typeof t && (t = e.apply(this, arguments)), t;
    };
  }(function () {
    return window && document && document.all && !window.atob;
  }),
      h = function (e) {
    var t = {};
    return function (n) {
      if ("undefined" === typeof t[n]) {
        var r = e.call(this, n);
        if (r instanceof window.HTMLIFrameElement) try {
          r = r.contentDocument.head;
        } catch (e) {
          r = null;
        }
        t[n] = r;
      }

      return t[n];
    };
  }(function (e) {
    return document.querySelector(e);
  }),
      m = null,
      v = 0,
      g = [],
      w = n(18);

  e.exports = function (e, t) {
    if ("undefined" !== typeof DEBUG && DEBUG && "object" !== (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");
    t = t || {}, t.attrs = "object" === _typeof(t.attrs) ? t.attrs : {}, t.singleton || (t.singleton = b()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
    var n = o(e, t);
    return r(n, t), function (e) {
      for (var i = [], a = 0; a < n.length; a++) {
        var u = n[a],
            c = y[u.id];
        c.refs--, i.push(c);
      }

      if (e) {
        r(o(e, t), t);
      }

      for (var a = 0; a < i.length; a++) {
        var c = i[a];

        if (0 === c.refs) {
          for (var s = 0; s < c.parts.length; s++) {
            c.parts[s]();
          }

          delete y[c.id];
        }
      }
    };
  };

  var O = function () {
    var e = [];
    return function (t, n) {
      return e[t] = n, e.filter(Boolean).join("\n");
    };
  }();
}, function (e, t) {
  e.exports = function (e) {
    var t = "undefined" !== typeof window && window.location;
    if (!t) throw new Error("fixUrls requires window.location");
    if (!e || "string" !== typeof e) return e;
    var n = t.protocol + "//" + t.host,
        r = n + t.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
      var o = t.trim().replace(/^"(.*)"$/, function (e, t) {
        return t;
      }).replace(/^'(.*)'$/, function (e, t) {
        return t;
      });
      if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(o)) return e;
      var i;
      return i = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? n + o : r + o.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")";
    });
  };
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" !== _typeof(t) && "function" !== typeof t ? e : t;
  }

  function i(e, t) {
    if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var a = n(0),
      u = n.n(a),
      c = n(20),
      s = n.n(c),
      l = n(1),
      f = n.n(l),
      p = n(2),
      d = n(5),
      y = (n.n(d), function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }()),
      b = function (e) {
    function t(e) {
      r(this, t);
      var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.getDomMarkerIcon = function (e) {
        return new window.H.map.DomIcon(e);
      }, n.createMarker = function () {
        n.marker && t.removeObject(n.marker);
        var e = n.props,
            t = e.map,
            r = e.children,
            o = e.lat,
            i = e.lng,
            a = e.draggable,
            c = s.a.renderToStaticMarkup(u.a.createElement("div", {
          className: "rc-marker"
        }, r)),
            l = n.getDomMarkerIcon(c),
            f = new window.H.map.DomMarker({
          lat: o,
          lng: i
        }, {
          icon: l
        });
        a && (f.draggable = !0, n.addEventListeners()), t.addObject(f), n.props.onMarkerCreated(f), n.marker = f;
      }, n.updateMarker = function () {
        var e = n.props.children,
            t = s.a.renderToStaticMarkup(u.a.createElement("div", {
          className: "rc-marker"
        }, e)),
            r = n.getDomMarkerIcon(t);
        n.marker.setIcon(r);
      }, n.updatePosition = function () {
        n.marker.setPosition({
          lat: n.props.lat,
          lng: n.props.lng
        });
      }, n.addEventListeners = function () {
        var e = n.props.map;
        e.addEventListener("dragstart", n.onDragStart, !1), e.addEventListener("dragend", n.onDragEnd, !1), e.addEventListener("drag", n.onDrag, !1);
      }, n.removeEventListeners = function () {
        var e = n.props.map;
        e.removeEventListener("dragstart", n.onDragStart, !1), e.removeEventListener("dragend", n.onDragStart, !1), e.removeEventListener("drag", n.onDragStart, !1);
      }, n.onDragStart = function (e) {
        var t = e.target,
            r = n.props.behavior;
        t instanceof window.H.map.DomMarker && r.disable();
      }, n.onDragEnd = function (e) {
        var t = e.target,
            r = n.props.behavior;
        t instanceof window.mapsjs.map.DomMarker && r.enable();
      }, n.onDrag = function (e) {
        var t = e.target,
            r = e.currentPointer,
            o = n.props.map;
        t instanceof window.mapsjs.map.DomMarker && t.setPosition(o.screenToGeo(r.viewportX, r.viewportY));
      }, n.marker = null, n;
    }

    return i(t, e), y(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        this.props.lat === e.lat && this.props.lng === e.lng || this.updatePosition();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var e = this.props,
            t = e.map,
            n = e.draggable;
        Object(p.a)(t) || (n && this.removeEventListeners(), t.removeObject(this.marker));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.map;
        return Object(p.a)(e) || this.marker ? this.marker && this.updateMarker() : this.createMarker(), null;
      }
    }]), t;
  }(a.Component);

  b.defaultProps = {
    lat: 0,
    lng: 0,
    onMarkerCreated: function onMarkerCreated() {},
    draggable: !1,
    behavior: {}
  }, b.propTypes = {
    lat: f.a.number.isRequired,
    lng: f.a.number.isRequired,
    onMarkerCreated: function onMarkerCreated() {},
    draggable: f.a.bool,
    behavior: f.a.object
  }, t.a = b;
}, function (e, t) {
  e.exports = require("react-dom/server");
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" !== _typeof(t) && "function" !== typeof t ? e : t;
  }

  function i(e, t) {
    if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var a = n(0),
      u = (n.n(a), n(1)),
      c = n.n(u),
      s = n(2),
      l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      f = function (e) {
    function t(e) {
      r(this, t);
      var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.getGeometry = function (e) {
        return new window.H.geo.Polygon(new window.H.geo.LineString(e, "lat lng alt"));
      }, n.createPolygon = function () {
        var e = n.props,
            t = e.map,
            r = e.fillColor,
            o = e.strokeColor,
            i = e.lineWidth,
            a = e.dataPoints,
            u = n.getGeometry(a);
        n.polygon = new window.H.map.Polygon(u, {
          style: {
            fillColor: r,
            strokeColor: o,
            lineWidth: i
          }
        }), n.props.onPolygonDrawn(n.polygon), t.addObject(n.polygon);
      }, n.updatePolygon = function () {
        var e = n.props.dataPoints,
            t = n.getGeometry(e);
        n.polygon.setGeometry(t);
      }, n.polygon = null, n;
    }

    return i(t, e), l(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        this.polygon && (Object(s.b)(e.dataPoints, this.props.dataPoints) || this.updatePolygon());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var e = this.props.map;
        Object(s.a)(e) || e.removeObject(this.polygon);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.map;
        return Object(s.a)(e) || this.polygon || this.createPolygon(), null;
      }
    }]), t;
  }(a.Component);

  f.defaultProps = {
    dataPoints: [],
    fillColor: "#FFFFCC",
    strokeColor: "#829",
    lineWidth: 1,
    onPolygonDrawn: function onPolygonDrawn() {}
  }, f.propTypes = {
    dataPoints: c.a.array,
    fillColor: c.a.string,
    strokeColor: c.a.string,
    lineWidth: c.a.number,
    onPolygonDrawn: c.a.func
  }, t.a = f;
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" !== _typeof(t) && "function" !== typeof t ? e : t;
  }

  function i(e, t) {
    if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var a = n(0),
      u = (n.n(a), n(1)),
      c = n.n(u),
      s = n(2),
      l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      f = function (e) {
    function t(e) {
      r(this, t);
      var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.updatePolyline = function () {
        var e = n.props.dataPoints,
            t = n.getGeometry(e);
        n.polyline.setGeometry(t);
      }, n.getGeometry = function () {
        return new window.H.geo.LineString(n.props.dataPoints, "lat lng alt");
      }, n.createPolyline = function () {
        var e = n.getGeometry(),
            t = n.props,
            r = t.map,
            o = (t.fillColor, t.strokeColor),
            i = t.lineWidth,
            a = t.miterLength,
            u = t.lineDash,
            c = t.lineDashOffset;
        n.polyline = new window.H.map.Polyline(e, {
          style: {
            strokeColor: o,
            lineWidth: i,
            miterLength: a,
            lineDash: u,
            lineDashOffset: c
          }
        }), n.props.onPolylineDrawn(n.polyline), r.addObject(n.polyline);
      }, n.polyline = null, n;
    }

    return i(t, e), l(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        this.polyline && (Object(s.b)(e.dataPoints, this.props.dataPoints) || this.updatePolyline());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var e = this.props.map;
        Object(s.a)(e) || e.removeObject(this.polyline);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.map;
        return Object(s.a)(e) || this.polyline || this.createPolyline(), null;
      }
    }]), t;
  }(a.Component);

  f.defaultProps = {
    dataPoints: [],
    strokeColor: "#829",
    lineWidth: 2,
    miterLength: 10,
    lineDash: [],
    lineDashOffset: 0,
    onPolylineDrawn: function onPolylineDrawn() {}
  }, f.propTypes = {
    dataPoints: c.a.array,
    strokeColor: c.a.string,
    lineWidth: c.a.number,
    miterLength: c.a.number,
    onPolylineDrawn: c.a.func
  }, t.a = f;
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" !== _typeof(t) && "function" !== typeof t ? e : t;
  }

  function i(e, t) {
    if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var a = n(0),
      u = (n.n(a), n(1)),
      c = n.n(u),
      s = n(2),
      l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      f = function (e) {
    function t(e) {
      r(this, t);
      var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.createCircle = function () {
        var e = n.props,
            t = e.map,
            r = e.fillColor,
            o = e.strokeColor,
            i = e.lineWidth,
            a = e.center,
            u = e.radius;
        n.circle = new window.H.map.Circle(a, u, {
          style: {
            fillColor: r,
            strokeColor: o,
            lineWidth: i
          }
        }), n.props.onCircleDrawn(n.circle), t.addObject(n.circle);
      }, n.updateCircle = function () {
        var e = n.props,
            t = e.center,
            r = e.radius;
        n.circle.setCenter(t), n.circle.setRadius(r);
      }, n.circle = null, n;
    }

    return i(t, e), l(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        this.circle && (Object(s.b)(e.center, this.props.center) && e.radius === this.props.radius || this.updateCircle());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var e = this.props.map;
        Object(s.a)(e) || e.removeObject(this.circle);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.map;
        return Object(s.a)(e) || this.circle || this.createCircle(), null;
      }
    }]), t;
  }(a.Component);

  f.defaultProps = {
    center: {},
    radius: 10,
    fillColor: "#FFFFCC",
    strokeColor: "#829",
    lineWidth: 2,
    onCircleDrawn: function onCircleDrawn() {}
  }, f.propTypes = {
    center: c.a.object.isRequired,
    radius: c.a.number,
    fillColor: c.a.string,
    strokeColor: c.a.string,
    lineWidth: c.a.number,
    onCircleDrawn: c.a.func
  }, t.a = f;
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" !== _typeof(t) && "function" !== typeof t ? e : t;
  }

  function i(e, t) {
    if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var a = n(0),
      u = (n.n(a), n(1)),
      c = n.n(u),
      s = n(2),
      l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      f = function (e) {
    function t(e) {
      r(this, t);
      var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.getGeometry = function (e) {
        return new window.H.geo.Rect(e.north, e.south, e.east, e.west);
      }, n.createRectangle = function () {
        var e = n.props,
            t = e.map,
            r = e.fillColor,
            o = e.strokeColor,
            i = e.lineWidth,
            a = e.bounds;
        n.rectangle = new window.H.map.Rect(n.getGeometry(a), {
          style: {
            fillColor: r,
            strokeColor: o,
            lineWidth: i
          }
        }), n.props.onRectangleDrawn(n.rectangle), t.addObject(n.rectangle);
      }, n.updateRectangle = function () {
        var e = n.props.bounds;
        n.rectangle.setBounds(n.getGeometry(e));
      }, n.rectangle = null, n;
    }

    return i(t, e), l(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        this.rectangle && (Object(s.b)(e.bounds, this.props.bounds) || this.updateRectangle());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var e = this.props.map;
        Object(s.a)(e) || e.removeObject(this.rectangle);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.map;
        return Object(s.a)(e) || this.rectangle || this.createRectangle(), null;
      }
    }]), t;
  }(a.Component);

  f.defaultProps = {
    bounds: {},
    fillColor: "#FFFFCC",
    strokeColor: "#829",
    lineWidth: 1,
    onRectangleDrawn: function onRectangleDrawn() {}
  }, f.propTypes = {
    bounds: c.a.object.isRequired,
    fillColor: c.a.string,
    strokeColor: c.a.string,
    lineWidth: c.a.number,
    onRectangleDrawn: c.a.func
  }, t.a = f;
}]);